var _a, _b;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@/inversify.config';
import { OnboardingModel } from '../models/onboarding-model.interface';
import { Disposable } from '@patsnap/tahiti-core/common/disposable';
import { OnBoardingRepository } from '../repositorys/onboarding-repository.interface';
let HomeOnBoardingServiceImpl = class HomeOnBoardingServiceImpl {
    constructor(_onBoardingRepository, _onboardingModel) {
        this._onBoardingRepository = _onBoardingRepository;
        this._onboardingModel = _onboardingModel;
    }
    get onboardingMessageList() {
        return this._onboardingModel.messageList;
    }
    addMessage(message) {
        this._onboardingModel.addMessage(message);
    }
    clearMessage() {
        this._onboardingModel.clearMessage();
    }
    subscribeMessages(callback) {
        const fn = this._onboardingModel.subscribeMessageList(callback);
        return Disposable.create(fn);
    }
    getSuggestCompanies() {
        return this._onBoardingRepository.getSuggestCompany();
    }
    createSpace(params) {
        return this._onBoardingRepository.createSpaceInfo(params);
    }
    getAssignCompany(params) {
        return this._onBoardingRepository.getAssignCompany(params);
    }
};
HomeOnBoardingServiceImpl = __decorate([
    injectable(),
    __param(0, inject(OnBoardingRepository)),
    __param(1, inject(OnboardingModel)),
    __metadata("design:paramtypes", [typeof (_a = typeof OnBoardingRepository !== "undefined" && OnBoardingRepository) === "function" ? _a : Object, typeof (_b = typeof OnboardingModel !== "undefined" && OnboardingModel) === "function" ? _b : Object])
], HomeOnBoardingServiceImpl);
export { HomeOnBoardingServiceImpl };
